module.exports = __webpack_public_path__ + "img/CLCL-product-identifier-white.0f717ba5.png";